import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  viewboxWidth: 10,
  viewboxHeight: 10,
  width: 10,
  height: 10,
};

const EnvelopIcon = ({
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  width = defaults.width,
  height = defaults.height,
}) => {
  return (
    <SVGLoader
      viewboxHeight={viewboxHeight}
      viewboxWidth={viewboxWidth}
      width={width}
      height={height}
    >
      <g>
        <path
          d="M9.95417 2.42914C9.94183 2.4209 9.92733 2.4165 9.9125 2.4165C9.89767 2.4165 9.88317 2.4209 9.87083 2.42914L5.80833 6.49164C5.70238 6.59796 5.57637 6.68218 5.43761 6.7394C5.29884 6.79662 5.1501 6.82571 5 6.82498C4.696 6.82438 4.40433 6.70472 4.1875 6.49164L0.129167 2.44581C0.116833 2.43757 0.102333 2.43317 0.0875 2.43317C0.0726669 2.43317 0.0581668 2.43757 0.0458333 2.44581C0.0343163 2.45035 0.0241033 2.45768 0.0161058 2.46713C0.00810836 2.47658 0.00257516 2.48787 0 2.49998L0 7.49998C0 7.72099 0.0877974 7.93295 0.244078 8.08923C0.400358 8.24551 0.61232 8.33331 0.833333 8.33331H9.16667C9.38768 8.33331 9.59964 8.24551 9.75592 8.08923C9.9122 7.93295 10 7.72099 10 7.49998V2.49998C10.0003 2.48493 9.99616 2.47014 9.98799 2.4575C9.97981 2.44487 9.96803 2.43499 9.95417 2.42914Z"
          fill="currentColor"
        />
        <path
          d="M4.62909 6.06675C4.72785 6.16271 4.86013 6.21639 4.99784 6.21639C5.13554 6.21639 5.26783 6.16271 5.36659 6.06675L9.40409 2.02925C9.43126 2.00192 9.45032 1.96759 9.45915 1.93007C9.46798 1.89256 9.46623 1.85333 9.45409 1.81675C9.40826 1.66675 9.27909 1.66675 9.16659 1.66675H0.833256C0.716589 1.66675 0.591589 1.66675 0.545756 1.81675C0.533619 1.85333 0.531867 1.89256 0.540694 1.93007C0.549522 1.96759 0.568582 2.00192 0.595756 2.02925L4.62909 6.06675Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default EnvelopIcon;
